// extracted by css-extract-rspack-plugin
export default {"savedViewsBar":"BxwqDgk9wGw8s3EC__savedViewsBar___","quickSelectMenu":"_Ii784iVYcRBrRUF__quickSelectMenu___"};